import get from '@invitato/helpers/dist/getLocale';

export default {
  title: get('Acara Pernikahan', 'Wedding Celebration'),
  subTitle: get('akan diselenggarakan pada:', 'will be held in:'),
  akadName: get('Pemberkatan', 'Holy Matrimony'),
  receptionName: get('Resepsi Pernikahan', 'Wedding Reception'),
  reminder: get('Ingatkan Acara', 'Remind Me'),
  location: get('Lihat Peta', 'See Location'),
};